export default __webpack_public_path__ + "static/media/alert_icon.02ddae82.svg";